var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "dense": "",
      "items": _vm.formats,
      "item-value": "id",
      "item-text": "value",
      "label": _vm.$t("format")
    },
    model: {
      value: _vm.store.formInfo.format,
      callback: function ($$v) {
        _vm.$set(_vm.store.formInfo, "format", $$v);
      },
      expression: "store.formInfo.format"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-text-field', {
    staticClass: "hsbcfield",
    attrs: {
      "label": _vm.$t('account'),
      "required": ""
    },
    on: {
      "blur": function ($event) {
        return _vm.store.updateSettings();
      }
    },
    model: {
      value: _vm.store.formInfo.accountNo,
      callback: function ($$v) {
        _vm.$set(_vm.store.formInfo, "accountNo", $$v);
      },
      expression: "store.formInfo.accountNo"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "max-width": "290px",
      "min-width": "290px",
      "nudge-top": 21,
      "nudge-right": 32
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "hsbcfield",
          attrs: {
            "readonly": "",
            "value": _vm.store.formInfo.date,
            "label": _vm.$t('settlementDate')
          },
          on: {
            "blur": function ($event) {
              return _vm.store.updateSettings();
            }
          }
        }, 'v-text-field', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.menu,
      callback: function ($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "no-title": ""
    },
    on: {
      "input": function ($event) {
        _vm.menu = false;
      }
    },
    model: {
      value: _vm.store.formInfo.date,
      callback: function ($$v) {
        _vm.$set(_vm.store.formInfo, "date", $$v);
      },
      expression: "store.formInfo.date"
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }